<template>
  <main class="flex-1 overflow-x-hidden overflow-y-hidden">
    <h3 class="text-gray-700 text-3xl font-medium">Tanques</h3>
    <span class="text-gray-400 text-sm">*Valores aproximados</span>
    <div class="grid grid-rows-1 lg:grid-cols-4 gap-4 py-4">
      <tank v-for="tanque in tanques" :key="tanque.idTanque" :tanque="tanque" />
    </div>

    <h3 class="text-gray-700 text-3xl font-medium">Dashboard</h3>
    <form class="w-full flex flex-col lg:flex-row py-2 space-x-0 lg:space-x-2 space-y-2 lg:space-y-0" @submit.prevent="update">
      <select-input v-model="since" class="w-full lg:w-1/2">
        <option value="daily">DIÁRIO</option>
        <option value="weekly">SEMANAL</option>
        <option value="monthly">MENSAL</option>
      </select-input>
      <loading-button class="btn-indigo w-full justify-center  lg:w-40"> Atualizar </loading-button>
    </form>
    <div class="mt-4">
      <div class="flex flex-wrap -mx-6 space-y-2 lg:space-y-0">
        <div class="w-full px-6 sm:w-1/2 xl:w-1/3">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600">VENDAS {{ labelSince }}</span>
            <div class="text-2xl text-indigo-600 py-2">{{ vendasDiaria.qtde }}</div>
            <h4 class="font-semibold text-gray-700">R$ {{ format(vendasDiaria.total) }}</h4>
          </div>
        </div>

        <div class="w-full px-6 sm:w-1/2 xl:w-1/3">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600">MÉDIO DE VENDA {{ labelSince }}</span>
            <div class="text-2xl text-indigo-600 py-2">R$ {{ format(tickMedio.media) }}</div>
            <h4 class="font-semibold text-gray-700">{{ vendasDiaria.qtde }} VENDAS</h4>
          </div>
        </div>

        <div class="w-full px-6 sm:w-1/2 xl:w-1/3 ">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600"> VENDAS {{ labelSince }}</span>
            <div class="text-2xl text-indigo-600 py-2">{{ format(vendaLitrosDiario.total) }}</div>
            <h4 class="font-semibold text-gray-700">LITROS</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="flex flex-wrap -mx-6 space-y-2 lg:space-y-0 ">
        <div class="w-full px-6 sm:w-full xl:w-2/3 bg-white shadow-sm rounded-md ">
          <div class="flex flex-col px-5 py-6 ">
            <span class="text-gray-600 font-bold">MÉDIA DE VENDA DOS COMBUSTÍVEIS {{ labelSince }}</span>
            <span class="text-gray-600 text-xs py-2" />
            <div class="py-2" />
            <VendaMediaCombustiveisChart :data="combutiveisMediaData(mediaVendaCombutiveis)" :options="optionsMedia" />
          </div>
        </div>
        <div class="w-full px-6 sm:w-full xl:w-1/3">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600 font-bold">VENDAS COMBUSTÍVEIS {{ labelSince }}</span>
            <span class="text-gray-600 text-xs py-2">R$ {{ format(combutiveisDataTotal(combutiveis)) }}</span>
            <div class="py-2" />
            <VendaCombutiveisChart :data="combutiveisData(combutiveis)" :options="optionsCombustiveis" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="flex flex-wrap -mx-6 space-y-2 lg:space-y-0 ">
        <div class="w-full px-6 sm:w-full xl:w-2/3 bg-white shadow-sm rounded-md ">
          <div class="flex flex-col px-5 py-6 ">
            <span class="text-gray-600 font-bold">TOTAL VENDAS POR DIA</span>
            <span class="text-gray-600 text-xs py-2">Últimos 30 dias</span>
            <div class="py-2" />
            <VendaUltimos30diasChart :data="vendasUltimos30dia(vendasUltimos30dias)" :options="optionsVendaUltimos30dias" />
          </div>
        </div>
        <div class="w-full px-6 sm:w-full xl:w-1/3">
          <div class="flex flex-col h-full px-4 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600 font-bold">VALORES POR FRENTISTAS {{ labelSince }}</span>
            <span class="text-gray-600 text-xs py-2" />
            <div class="py-2" />
            <ul class="flex flex-col space-y-2">
              <vendedor-rank-item v-for="(rank, index) in frentistas" :key="rank.idFrentista" :rank="index+1" :vendedor="rank" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import { DateTime } from 'luxon'
import VendaCombutiveisChart from '@/Shared/Charts/VendaCombustiveisChart.vue'
import VendaMediaCombustiveisChart from '@/Shared/Charts/VendaMediaCombustiveisChart.vue'
import VendaUltimos30diasChart from '@/Shared/Charts/VendaUltimos30diasChart.vue'
import { getHexColor } from '@/Utils/colors'
import { format } from '@/Utils/money'
import VendedorRankItem from '../../Shared/VendedorRankItem.vue'
import LoadingButton from '../../Shared/LoadingButton.vue'
import Tank from '../../Shared/Tank.vue'
export default {
  components: { VendaCombutiveisChart, VendaMediaCombustiveisChart, VendedorRankItem, VendaUltimos30diasChart, SelectInput, LoadingButton, Tank },
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  props: {
    tanques: Array,
    vendas: Object,
    filters: Object,
    vendasDiaria: Object,
    tickMedio: Object,
    combutiveis: Array,
    mediaVendaCombutiveis: Array,
    frentistas: Array,
    vendasUltimos30dias: Array,
    vendaLitrosDiario: Object,
    labelSince: String,
  },
  data: () => ({
    since: 'daily',
    optionsCombustiveis: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
      },
      tooltips: {
        callbacks: {
          label (tooltip, data){
            return format(data['datasets'][0]['data'][tooltip['index']]) + 'L'
          },
        },
      },

    },

    optionsMedia: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
      },
      tooltips: {
        callbacks: {
          label (tooltip){
            return 'R$ '+ format(tooltip.yLabel)
          },
        },
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false,
          },
        }],
        yAxes: [{
          gridLines: {
            drawOnChartArea: true,
          },
        }],
      },
    },
    optionsVendaUltimos30dias: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          label (tooltip){
            return 'R$ '+ format(tooltip.yLabel)
          },
        },
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false,
          },
        }],
        yAxes: [{
          gridLines: {
            drawOnChartArea: true,
          },
        }],
      },
    },
  }),
  created(){
    if(this.filters.since){
      this.since = this.filters.since
    }
  },
  methods: {
    statusBgColor(venda) {
      return {
        'bg-green-100 text-green-800': venda.status == 'F',
        'bg-blue-100 text-green-800': venda.status == 'A',
        'bg-red-100 text-green-800': venda.status == 'C',
      }
    },
    dtVenda(venda) {
      const dt = DateTime.fromSQL(venda.dtVenda)
      return dt.toFormat('dd/MM/yyyy') + ` ${venda.hrVenda}`
    },
    format,
    total(venda) {
      return this.format(venda.vTotal)
    },
    combutiveisData(combutiveis) {
      return {
        labels: combutiveis.map((row) => row.nome),
        datasets: [
          {
            backgroundColor: combutiveis.map((row) => getHexColor(row.cor)),
            data: combutiveis.map((row) => row.QtdeVendida),
          },
        ],
      }
    },
    combutiveisMediaData(combutiveis) {
      return {
        labels: combutiveis.map((row) => row.nome),
        datasets: [
          {
            label: 'Média de Vendas',
            backgroundColor: combutiveis.map((row) => getHexColor(row.cor)),
            data: combutiveis.map((row) => parseFloat(row.media).toFixed(3)),
          },
        ],
      }
    },
    vendasUltimos30dia(vendas) {
      return {
        labels: vendas.map(function (row) {
          const dtNow = DateTime.now()
          const dtAbastecimento = DateTime.fromISO(row.dtAbastecimento)
          if(dtNow.year != dtAbastecimento.year){
            return dtAbastecimento.toFormat('dd/MM/yyyy')
          }

          return dtAbastecimento.toFormat('dd/MM')
        }),
        datasets: [
          {
            data: vendas.map((row) => parseFloat(row.total).toFixed(3)),
            borderColor: '#36a2eb',
            fill: false,
          },
        ],
      }
    },
    combutiveisDataTotal(combutiveis) {
      return combutiveis.reduce((acc, current) => acc + parseFloat(current.ValorTotal), 0)
    },
    update(){
      console.log(this.since)
      this.$inertia.get(this.route(this.route().current(), {}), {
        since: this.since,
      })

    },
  },
}
</script>
